import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateEmailTemplate = {
  name: "updateEmailTemplate" as const,
  input: z.object({
    emailTemplateId: zExt.objectId(),
    updates: emailTemplateSchema.partial(),
  }),
  output: emailTemplateSchema,
};
